<template lang="pug">
    div.report-list(v-if="currentComponent")
        component(
            :is="currentComponent"
            ref="reportListViewComponent"
        )
</template>

<script>
export default {
    name: 'ReportListView',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-report/views/pages/view/components/report-list/content.vue')
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
</style>
